import useCalendarStore from '@/store/calendarStore';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const useSearchResults = () => {
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get('q') || '';
  const startDate = searchParams.get('start') || '';
  const endDate = searchParams.get('end') || '';

  const searchQuery = {
    keyword,
    startDate,
    endDate,
  };

  const { isLoading, searchEvents, checkedEvent } = useCalendarStore();
  const events = useMemo(
    () => (isLoading ? [] : searchEvents(searchQuery, checkedEvent)),
    [searchQuery, checkedEvent, searchEvents, isLoading]
  );

  return {
    events,
    isLoading,
  };
};

export { useSearchResults };
